'use client';

import cx from 'classix';
import { useTranslations } from 'next-intl';

import { setCookieRedirectAfterAuth } from '@/features/auth/cookies/cookie-redirect-after-auth';
import useAppFlyerLink from '@/features/roomster-app/hooks/use-app-flyer-link';
import { ROUTER_LINKS } from '@/shared/constants/links-constants';
import Button from '@/ui/button/button';

import styles from './add-listing-button.module.scss';

export default function AddListingButton() {
  const translationsListing = useTranslations('listing');

  const addListingAppFlyer = useAppFlyerLink('mobile', 'mobileSearchAddListingButton', ROUTER_LINKS.phoneAuth);

  const handleNonLoggedClick = () => {
    setCookieRedirectAfterAuth(ROUTER_LINKS.listingsAdd);
  };

  return (
    <div className={cx(styles.addListing)}>
      <Button
        href={addListingAppFlyer}
        onClick={handleNonLoggedClick}
        element="link"
        shade="dark"
        variant="filled"
        size="md"
        fontSize="s"
        fullWidth
      >
        +
        {' '}
        {translationsListing('add-listing')}
      </Button>
    </div>
  );
}
